const Constants = {
		unit : {
			day: "DAY",
			week:"WEEK",
			month:"MONTH",
		},
		view : {
			main : "MAIN",
			comparison : "COMPARISON",
			table: "TABLE"
		}
}

export default Constants;



// WEBPACK FOOTER //
// ./src/utils/Constants.js